/*
  PhaseOne — Add to cart "Added" flourish.
  Listens for the theme's cartUpdate pub/sub event (fired by product-form.js on a
  successful add) and briefly morphs the Add to cart button to a success state.
  Purely additive: does not touch Dawn's product-form / cart logic, and no-ops on
  failed adds (the event only fires on success).
*/
(function () {
  function flourish(event) {
    if (!event || event.source !== 'product-form') return;
    document
      .querySelectorAll('.product__info-container .product-form__submit')
      .forEach(function (btn) {
        if (btn.dataset.flourishing) return;
        var label = btn.querySelector('span');
        if (!label) return;
        btn.dataset.flourishing = '1';
        var originalText = label.textContent;
        label.innerHTML =
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="3" stroke-linecap="round" stroke-linejoin="round" ' +
          'style="vertical-align:-3px;margin-right:7px"><polyline points="20 6 9 17 4 12"></polyline></svg>Added';
        btn.style.background = '#12945f';
        setTimeout(function () {
          label.textContent = originalText;
          btn.style.background = '';
          delete btn.dataset.flourishing;
        }, 1600);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, flourish);
    }
  });
})();
